import React from 'react';
import ReactDOM from 'react-dom';
import './style/style.css'
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import './i18n'
// import Router from './route/index';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware, compose } from 'redux'
import rootReducer from './redux/reducers'
import createSagaMiddleware from 'redux-saga'
import rootSaga from './redux/sagas'
import App from './App';
//import { getCookie, getLanguageConference, setCookie } from './helpers';

const sagaMiddleware = createSagaMiddleware()
const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

//set cookie form conference
// const conferenceLang = getLanguageConference()
// setCookie("language", !conferenceLang ? getCookie('language') : conferenceLang)

const store = createStore(
  rootReducer,
  composeEnhancer(applyMiddleware(sagaMiddleware))
)

sagaMiddleware.run(rootSaga)


const AppWithRouter = () => (
  <BrowserRouter>
    <App />
  </BrowserRouter>
)

ReactDOM.render(
  <Provider store={store}>
    <AppWithRouter />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
